"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderVideoPlaylist = exports.renderPlaylistItem = void 0;
var React = require("react");
var classnames_1 = require("classnames");
exports.renderPlaylistItem = function (video, id, isPlaying, onPlaylistClick) {
    var active = id === video.src && isPlaying;
    var itemClass = classnames_1.default([
        'c-playlist__item',
        {
            'c-playlist__item--active': id === video.src,
        },
    ]);
    var onClick = function () { return onPlaylistClick(video); };
    return (React.createElement("div", { onClick: onClick, className: itemClass },
        React.createElement("div", { className: "c-playlist__image" },
            React.createElement("img", { src: video.thumb, alt: "" })),
        React.createElement("div", { className: "c-playlist__info" },
            React.createElement("div", { className: "c-playlist__title" }, video.title),
            React.createElement("div", { className: "c-playlist__caption" }, video.caption)),
        React.createElement("div", { className: "c-playlist__icon" }, active ? (React.createElement("span", { className: "fal fa-play-circle" })) : null)));
};
exports.renderVideoPlaylist = function (props, type) {
    return (React.createElement("div", { className: "c-playlist" },
        React.createElement("div", { className: "c-playlist__head" },
            props.t.video,
            " - ",
            props.videos.length),
        React.createElement("div", { className: "c-playlist__items" }, props.videos.map(function (video) {
            return exports.renderPlaylistItem(video, props.videoPlayer.id, props.videoPlayer.isPlaying, props.onPlaylistClick);
        }))));
};
